import LoadingSkeleton from '@components/LoadingSkeleton';
import { twcls } from '@utils/twcls';
import { memo, type FC } from 'react';

const PPLoading: FC = () => (
  <div className={twcls('main-container sm:px-3 md:px-6.25')}>
    <LoadingSkeleton className='w-124 h-4 mb-2.5 mt-2.5 allMd:mb-2.5 allMd:w-full' />
    <div
      className={twcls(`allMd:w-full
    grid
    mt-4
    mb-9
    allMd:mb-2
    gap-x-[3.75rem]
    grid-cols-[63.75rem_20rem]
    lg:grid-cols-[54.375rem_20rem]
    lg:gap-x-[3.125rem]
    allMd:mt-0
    allMd:block
    allMd:grid-cols-none
    allMd:gap-x-0`)}
    >
      <div className='allMd:block  grid grid-cols-2 gap-x-[3.75rem] '>
        <div className='flex items-center w-full allMd:flex-col-reverse'>
          <div className='flex flex-col justify-center gap-y-3 allMd:flex-row allMd:my-2.5 allMd:mr-0 mr-6'>
            {Array.from({ length: 5 }, (_, index) => (
              <LoadingSkeleton
                key={index}
                className='h-[3.125rem] allMd:h-0.5 w-[3.125rem]'
              />
            ))}
          </div>
          <LoadingSkeleton className='w-full h-[25rem] allMd:h-64 ' />
        </div>
        <div className='flex-1 w-full h-64 allMd:hidden'>
          <LoadingSkeleton className='w-full h-6 mb-5' />
          <LoadingSkeleton className='w-full mb-5 h-7' />
          <LoadingSkeleton className='w-full h-6 mb-5' />
          <LoadingSkeleton className='w-full h-5 mb-5' />
          <LoadingSkeleton className='w-full h-5 mb-5' />
          <LoadingSkeleton className='w-full h-[2.5rem] mb-5' />
          <div className='w-full h-[3.125rem] mb-4'>
            <LoadingSkeleton className='h-full mr-3 w-44' />
            <LoadingSkeleton className='w-[3.125rem] h-full' />
          </div>
          <LoadingSkeleton className='w-full h-4 mb-5' />
          <LoadingSkeleton className='w-full h-4' />
        </div>
      </div>
      <div className='allMd:hidden'>
        <LoadingSkeleton className='w-full h-64 mb-6' />
        <LoadingSkeleton className='w-full h-40' />
      </div>
    </div>
    <div className='fromLg:hidden'>
      <LoadingSkeleton className='w-full h-4 mb-3' />
      <div className='flex flex-col mb-3'>
        <LoadingSkeleton className='block h-4 mb-3 w-52' />
        <LoadingSkeleton className='block w-48 h-4' />
      </div>
      <div className='flex items-center mb-4 gap-x-3'>
        {Array.from({ length: 3 }, (_, index) => (
          <LoadingSkeleton key={index} className='h-5 w-36' />
        ))}
      </div>
    </div>
    <div className=''>
      <div className='flex items-center mb-6 gap-x-3'>
        {Array.from({ length: 5 }, (_, index) => (
          <LoadingSkeleton key={index} className='h-11 w-28' />
        ))}
      </div>
      <div className=''>
        {Array.from({ length: 7 }, (_, index) => (
          <div
            key={index}
            className='flex items-center w-full mb-4 allMd:flex-col allMd:gap-x-3 allMd:items-start'
          >
            <div className='w-[11.375rem] h-4 allMd:mb-2'>
              <LoadingSkeleton
                style={{
                  width: `${(index + 1) * 16}px`
                }}
              />
            </div>
            <LoadingSkeleton
              style={{
                width: `${(index + 1) * 64}px`
              }}
            />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default memo(PPLoading);
